import { useEffect } from "react";
// eslint-disable-next-line no-restricted-imports -- TODO: update to `next/navigation` before using this component in App Router
import { useRouter } from "next/router";

import { useDispatch, useSelector } from "@/redux/hooks";
import { DISABLE_LOCATION_CHANGE_RELOAD } from "@/redux/reducers/header";
import { getGeoSlug } from "@/redux/selectors/location";
import parseNextRouterAsPath from "utils/parseNextRouterAsPath";
import { leaflyShopStringify } from "utils/qs";

const useSyncUrlWithLocation = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const reduxLocationSlug = useSelector(getGeoSlug);

  // * Disable the location change reload from the LocationPicker component since we are handling the reload here
  dispatch({
    type: DISABLE_LOCATION_CHANGE_RELOAD,
  });

  useEffect(() => {
    if (reduxLocationSlug) {
      // * City / State was successfully resolved from Redux
      const {
        path,
        query: { location: routeLocationSlug, ...otherQueryParams },
      } = parseNextRouterAsPath(router.asPath);

      if (routeLocationSlug && routeLocationSlug !== reduxLocationSlug) {
        // * ...but the location query string param does not match
        router.push(
          {
            pathname: path,
            query: leaflyShopStringify({
              location: reduxLocationSlug,
              ...otherQueryParams,
            }),
          },
          undefined,
          { shallow: false },
        );
      }
    }
  }, [router, reduxLocationSlug]);
};

export default useSyncUrlWithLocation;
